<template>
  <a-modal
    ref="createModal"
    title="添加MDS/MPS计划"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    okText="保存"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增记录</a-button>
    </div>
    <a-table
      :columns="columns"
      :data-source="tableList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ y: 260 }"
    >
      <span slot="scheduleNameTitle">
        <i class="toRequired">*</i>计划名称
      </span>
      <span slot="descriptionTitle">
        <i class="toRequired">*</i>说明
      </span>
      <span slot="scheduleTypeTitle">
        <i class="toRequired">*</i>计划类型
      </span>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.dataIndex === 'operation'" class="table-line">
            <a @click="handleDelete(tableList, record)">删除</a>
            <a-tag v-if="record.message" color="red" class="tag">{{ record.message }}</a-tag>
          </span>
          <span v-else-if="item.type === 'select'">
            <global-select
              :value.sync="record[item.dataIndex]"
              :selectType="item.selectType ? item.selectType : 'select'"
              :requestApi="item.requestApi"
              :selectData="setArray(item.dataList)"
              :selectItem="{ value: item.value, label: item.label, thirdLabel: item.thirdLabel }"
              :searchParam="item.searchParam ? item.searchParam : ''"
              :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
              :sourseField="item.sourseField ? item.sourseField : ''"
              :allowClear="false"
              :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
            />
          </span>
          <span v-else-if="item.type === 'input'">
            <a-input v-model="record[item.dataIndex]" />
          </span>
        </div>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { apiAddScpMrpScheduleNames } from '@/api/scp/planSetting/dms-mps-name'
import { mapState } from 'vuex'
// 表单字段
export default {
  props: {},
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '计划名称',
          width: 150,
          dataIndex: 'scheduleName',
          scopedSlots: { customRender: 'scheduleName', title: "scheduleNameTitle" },
          type: "input"
        },
        {
          // title: '说明',
          width: 150,
          dataIndex: 'description',
          scopedSlots: { customRender: 'description', title: "descriptionTitle" },
          type: "input"
        },
        {
          // title: '计划类型',
          width: 150,
          dataIndex: 'scheduleType',
          scopedSlots: { customRender: 'scheduleType', title: "scheduleTypeTitle" },
          type: "select",
          requestApi: "/system/lookup/data/list",
          value: 'lookupCode',
          label: 'lookupValue',
          setParams: true
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      tableList: []
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {},
  methods: {
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.tableList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        scheduleName: "",
        description: "",
        scheduleType: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.tableList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.tableList.length; i++) {
        this.tableList[i].organizationCode = this.organizationCodeOrigin
        if (!this.tableList[i].scheduleName || !this.tableList[i].description || !this.tableList[i].scheduleType) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiAddScpMrpScheduleNames(this.tableList).then(response => {
        if (response.code === 200) {
          if (response.data && response.data.length > 0) {
            const arr = JSON.parse(JSON.stringify(this.tableList))
            arr.forEach(element => {
              element.message = ""
            });
            response.data.forEach(element => {
              arr[Number(element.lineNum) - 1].message = element.message
            });
            this.tableList = arr
            this.$message.error(response.data[0].message)
            this.confirmLoading = false
            return
          }
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.tableList = []
    },
    setArray (arr) {
      return this[arr]
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "scheduleType") {
        return { lookupType: 'SCP_MS_TYPE' }
      }
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 170px;
}
input{
  width: 170px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
.table-line{
  position: relative;
  .tag{
    position: absolute;
    left: -605px;
    bottom: -31px;
    z-index: 10000000;
  }
}
</style>
